import { render, staticRenderFns } from "./detialReceipt.vue?vue&type=template&id=44ca6d07&scoped=true&"
import script from "./detialReceipt.vue?vue&type=script&lang=js&"
export * from "./detialReceipt.vue?vue&type=script&lang=js&"
import style0 from "./detialReceipt.vue?vue&type=style&index=0&id=44ca6d07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ca6d07",
  null
  
)

export default component.exports